export default __webpack_public_path__ + "static/media/icone-hebergement.6b0f4706.svg";